/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostApiBookingSequentialMutationRequest, PostApiBookingSequentialMutationResponse, PostApiBookingSequentialQueryParams } from "../entities/PostApiBookingSequential";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { postApiBookingSequential } from "../api/postApiBookingSequential";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const postApiBookingSequentialMutationKey = () => [{ url: '/api/booking/sequential' }] as const

export type PostApiBookingSequentialMutationKey = ReturnType<typeof postApiBookingSequentialMutationKey>

export function postApiBookingSequentialMutationOptions<TContext = unknown>(config: Partial<RequestConfig<PostApiBookingSequentialMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = postApiBookingSequentialMutationKey()
        return mutationOptions<PostApiBookingSequentialMutationResponse, ResponseErrorConfig<Error>, {data: PostApiBookingSequentialMutationRequest, params: PostApiBookingSequentialQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ data, params }) => {
            return postApiBookingSequential(data, params, config)
          },
        })

}

/**
 * @description Создание последовательных записей для родителя и ребенка
 * @summary Создать последовательную запись
 * {@link /api/booking/sequential}
 */
export function usePostApiBookingSequential<TContext>(options: 
{
  mutation?: UseMutationOptions<PostApiBookingSequentialMutationResponse, ResponseErrorConfig<Error>, {data: PostApiBookingSequentialMutationRequest, params: PostApiBookingSequentialQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<PostApiBookingSequentialMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? postApiBookingSequentialMutationKey()

          const baseOptions = postApiBookingSequentialMutationOptions(config) as UseMutationOptions<PostApiBookingSequentialMutationResponse, ResponseErrorConfig<Error>, {data: PostApiBookingSequentialMutationRequest, params: PostApiBookingSequentialQueryParams}, TContext>
          

          return useMutation<PostApiBookingSequentialMutationResponse, ResponseErrorConfig<Error>, {data: PostApiBookingSequentialMutationRequest, params: PostApiBookingSequentialQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<PostApiBookingSequentialMutationResponse, ResponseErrorConfig<Error>, {data: PostApiBookingSequentialMutationRequest, params: PostApiBookingSequentialQueryParams}, TContext>
      
}